import React, { useContext } from 'react'
import InstructorMale from '../../../assets/inst-male.webp'
import InstructorFemale from '../../../assets/inst-female.webp'
import InstructorBG from '../../../assets/inst-bg.webp'
import { Link } from 'react-router-dom'
import { sellerBaseUrl } from '../../../constants'
import { settingsContext } from '../../../Context/settingsProvider'

export default function L4() {
  const {t} = useContext(settingsContext)

  return (
    <div className='w-full p-10 flex gap-12 items-center justify-evenly max-md:flex-col bg-cover' style={{
      backgroundImage: 'url(' + InstructorBG + ')'
    }}>
      <div className='relative flex flex-col'>
          <img src={InstructorFemale} alt='instructor' className='w-[250px] object-cover rounded-md shadow-lg' />
          <img src={InstructorMale} alt='instructor' className='w-[250px] translate-y-[-50px] shadow-lg translate-x-[50%] object-cover rounded-md max-md:hidden' />
      </div>
        <div className='flex flex-col gap-5'>
            <h1 className='text-white text-4xl font-bold'>{t('SELL_YOUR_COURSE')}</h1>
            <p className='text-sm text-white'>Join Hulluware! <br /> Whether you're an individual or an organization, <br /> expand your reach to a larger audience.</p>
            <a href={sellerBaseUrl} target='_blank' className='p-2 pl-3 pr-3 rounded-sm bg-main text-white font-bold no-underline text-md w-fit'>{t('START_TODAY')}</a>
        </div>
        <img src={InstructorMale} alt='instructor' className='w-[250px] hidden max-md:block shadow-lg object-cover rounded-md' />
       
    </div>
  )
}
